import axios from 'axios';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getClient = async clientId => {
  return (await requestFunnel.get(`clients/${clientId}`, getOptions())).data;
};

export const getDefaultingClients = async (
  dueDate, maxDefaultingDays, minDefaultingDays, numberOfDefaultingPayments, onlyOperationWithMostDefaultingMonth,
  documentsPerPage, pageNumber, typeOperation, operationSubType, operationOrigin, operationInvestor, includeGraceMonths, cancelExecutor
) => {
  const options = getOptions();
  options.params = { dueDate, maxDefaultingDays, minDefaultingDays, numberOfDefaultingPayments, onlyOperationWithMostDefaultingMonth, documentsPerPage, pageNumber };
  if (typeOperation) options.params.typeOperation = typeOperation;
  if (operationSubType) options.params.operationSubType = operationSubType;
  if (operationOrigin) options.params.operationOrigin = operationOrigin;
  if (operationInvestor) options.params.lastInvestorId = operationInvestor;
  if (includeGraceMonths) options.params.includeGraceMonths = includeGraceMonths;
  options.cancelToken = new axios.CancelToken(cancelExecutor);
  return (await requestFunnel.get('clients/defaulting', options)).data;
};

export const getClientDebt = async (clientId, date, cancelExecutor) => {
  const options = getOptions();
  if (cancelExecutor) {
    const cancelToken = new axios.CancelToken(cancelExecutor);
    options.cancelToken = cancelToken;
  }
  options.params = { date };
  return (await requestFunnel.get(`debt/${clientId}`, options)).data;
};

export const getClientDebtWithInactiveOperations = async (clientId, date, cancelExecutor) => {
  const options = getOptions();
  if (cancelExecutor) {
    const cancelToken = new axios.CancelToken(cancelExecutor);
    options.cancelToken = cancelToken;
  }
  options.params = { date };
  return (await requestFunnel.get(`debt/${clientId}?includeInactiveOperations=true`, options)).data;
};

export const getClientBoletos = async (clientId, status, cancelExecutor) => {
  const options = getOptions();
  if (cancelExecutor) {
    const cancelToken = new axios.CancelToken(cancelExecutor);
    options.cancelToken = cancelToken;
  }
  let endpoint = `clients/${clientId}/boletos`;
  if (status !== 'undefined') endpoint += `?status=${status}`;
  return (await requestFunnel.get(endpoint, options)).data;
};

export const setOrUnsetClientDefaultAsBeingManagedByCurrentUser = async clientId => {
  return (await requestFunnel.patch(`clients/${clientId}`, {}, getOptions())).data;
};

export const setOrUnsetClientTrustedIdNumbers = async (clientId, trustedIdNumbers) => {
  return (await requestFunnel.patch(`clients/${clientId}/trustedIdNumbers`, trustedIdNumbers, getOptions())).data;
};

export const getClientsWithDefaults = async (clientsIds, from, to) => {
  const options = getOptions();
  options.params = { clientsIds, from, to };
  return (await requestFunnel.get('clients/defaults', options)).data;
};

export const createClientDefault = async (clientId, clientDefaultToCreate) => {
  return (await requestFunnel.post(`clients/${clientId}/defaults`, clientDefaultToCreate, getOptions())).data;
};

export const getContactMethods = async () => (await requestFunnel.get('clients/contact-methods', getOptions())).data;

export const getClientDocumentsList = async clientId => (await requestFunnel.get(`clients/${clientId}/documents`, getOptions())).data;

export const getClientDocument = async (clientId, documentKey) => {
  const options = getOptions();
  options.responseType = 'blob';
  const result = await requestFunnel.get(`clients/${clientId}/documents/${documentKey}`, options);
  return result.data;
};

export const findClientsBySearchString = async (searchString, cancelExecutor) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.params = { searchString };
  options.cancelToken = cancelToken;
  return (await requestFunnel.get('clients', options)).data;
};

export const getClientCodebtorByClientId = async clientId => {
  return (await requestFunnel.get(`clients/${clientId}/client-codebtor`, getOptions())).data;
};

export const getClientResumeByClientId = async clientId => {
  return (await requestFunnel.get(`clients/${clientId}/client-credit-resume`, getOptions())).data;
};

export const getClientBalance = async clientId => {
  return (await requestFunnel.get(`clients/client-balance/${clientId}`, getOptions())).data;
};
